import Proptypes from 'prop-types'
import SoundCloudPlayer from 'react-player/lib/players/SoundCloud'
import { useOnlineStatus } from '../../hooks/useOnlineStatus'
import PwaOfflinePlaceholder from 'components/PwaOfflinePlaceholder'

import { StyledSoundCloudContainer } from './styles'

const SoundCloud = ({ part }) => {
  const online = useOnlineStatus();

  return (online ? <StyledSoundCloudContainer>
    <SoundCloudPlayer url={part.url} width="100%" height="300px" />
  </StyledSoundCloudContainer> : <PwaOfflinePlaceholder />)
}

SoundCloud.propTypes = {
  part: Proptypes.object,
}

export default SoundCloud
